import { useState } from 'react';
import { Box, Button, TextField } from '@mui/material';
import { css } from '@emotion/react';

const containerStyle = css({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    maxWidth: 600,
    padding: '32px',
});

export function QueueProcessingServerUpload() {
    const [filePath, setFilePath] = useState('');

    return (
        <Box css={containerStyle}>
            <TextField
                label="Server File Path"
                placeholder="/data/files/example.segy"
                value={filePath}
                onChange={(e) => setFilePath(e.target.value)}
                fullWidth
                variant="outlined"
            />
            <Button
                variant="contained"
                disabled={filePath.trim() === ''}
                sx={{ alignSelf: 'flex-start' }}
            >
                Upload
            </Button>
        </Box>
    );
}
